import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

function loadLanguage(lang) {
    const langValue = localStorage.getItem(`lang_${lang}`);
    if (langValue) {
        return JSON.parse(langValue);
    }

    return require(`./locales/${lang}.json`);
}

i18n.use(initReactI18next).init({
    // fallbackLng: 'tr',
    lng: localStorage.getItem('i18n-lng') || 'tr',
    resources: {
        tr: {
            translations: loadLanguage('tr'),
        },
        en: {
            translations: loadLanguage('en'),
        },
    },
    ns: ['translations'],
    defaultNS: 'translations',
});

i18n.languages = ['tr', 'en'];

export default i18n;
